var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:{
        'anchortabs text-center pt-0 pb-0 bg--dkblue': true,
        'anchortabs--md-and-down': _vm.$vuetify.breakpoint.mdAndDown,
        'anchortabs--lg-and-up': _vm.$vuetify.breakpoint.lgAndUp
    },attrs:{"id":_vm.section._id,"fluid":""}},[_c('v-row',{attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-col',{staticClass:"pt-0 pb-0",attrs:{"cols":"12"}},[_c('CtaLinks',{attrs:{"links":_vm.section.ctaLinks.links,"layout":"AnchorTabs"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }